// Cut-to-size cart lines display quantity as a piece count (e.g. "2"), but
// Shopify's actual cart quantity is a board-foot pricing unit count (e.g.
// 76 = 2 pieces x 38 units/piece). Rather than rewriting the visible input's
// value to the real unit count (which caused a visible flash to "76" before
// the server-rendered response corrected it back to "2"), this intercepts
// the change event before Dawn's own <cart-items>/<cart-drawer-items>
// listener sees it, and calls its updateQuantity() method directly with the
// correct real quantity. That method only ever uses the quantity argument
// passed to it -- it doesn't re-read the input's value -- so the visible
// box never needs to show anything but the piece count.
document.addEventListener(
  'change',
  (event) => {
    const input = event.target;
    if (!input || !input.matches || !input.matches('.quantity__input[data-units-per-piece]')) return;

    const unitsPerPiece = parseFloat(input.dataset.unitsPerPiece);
    if (!unitsPerPiece) return;

    const cartItemsEl = input.closest('cart-items, cart-drawer-items');
    if (!cartItemsEl || typeof cartItemsEl.updateQuantity !== 'function') return;

    event.stopImmediatePropagation();

    const pieceCount = Math.max(1, parseInt(input.value, 10) || 1);
    const realQuantity = pieceCount * unitsPerPiece;
    const line = input.dataset.index;
    const name = document.activeElement ? document.activeElement.getAttribute('name') : null;
    const variantId = input.dataset.quantityVariantId;

    cartItemsEl.updateQuantity(line, realQuantity, event, name, variantId);
  },
  true
);
